import { render, staticRenderFns } from "./ApproverReportTable.vue?vue&type=template&id=3ad7489d"
import script from "./ApproverReportTable.vue?vue&type=script&lang=js"
export * from "./ApproverReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports